import { render, staticRenderFns } from "./casa-ferreirinha.vue?vue&type=template&id=3aef5597&scoped=true"
import script from "./casa-ferreirinha.vue?vue&type=script&lang=js"
export * from "./casa-ferreirinha.vue?vue&type=script&lang=js"
import style0 from "./casa-ferreirinha.vue?vue&type=style&index=0&id=3aef5597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef5597",
  null
  
)

export default component.exports